/**
 * @file src/utils/rankPolicy.js
 * @description Owner-group and rank helpers for impersonation-aware UI.
 *
 * ── Why this file is now four lines of re-export ─────────────────────
 *
 * It held its own copy of the rank table and the owner-role list — five rows
 * each — under a comment reading "if you change one table, change the other".
 * Nobody did. The canonical list had grown to twenty roles, so the fifteen
 * this file had never heard of resolved to `groupForRole → 'user'` and
 * `rankForRole → 0`. `AdminRoute` gates on `isOwnerGroup`, so a content
 * moderator or a data protection officer signing in was treated as a customer
 * and bounced off every admin page, and `IdentityConsole` rendered their role
 * badge as "USER".
 *
 * `packages/common/src/permissions/ownerRoles.js` exists precisely to end
 * that — its own header records collapsing the dashboard's six copies. This
 * was the seventh, and it was missed.
 *
 * Server-side checks remain the authority; this only decides which controls
 * are worth rendering.
 */
export {
  OWNER_ROLES as OWNER_ROLE_LIST,
  OWNER_RANK as RANK,
  groupForRole,
  rankForRole,
  canImpersonate as canImpersonateDecision
} from '@moksy/common/src/permissions/ownerRoles.js';

import {
  isOwnerRole,
  canImpersonate as decide
} from '@moksy/common/src/permissions/ownerRoles.js';

export const isOwnerGroup = (actor) => isOwnerRole(actor?.role || '');

/**
 * Boolean form, kept because every caller in the dashboard consumes it that
 * way. The shared helper returns `{ allow, reason }` — the reason is what the
 * gateway logs on a refusal, and the UI has nowhere to put it.
 */
export const canImpersonate = (actor = {}, target = {}) => decide(actor, target).allow === true;

export default { isOwnerGroup, canImpersonate };
